<script setup>
import { computed } from "vue";

import { useLayout } from "@/layout/composables/layout";
const { setThemeMode, getThemeMode } = useLayout();

const options = [
  { icon: "pi pi-sun", value: "light" },
  { icon: "pi pi-moon", value: "dark" },
  { icon: "pi pi-desktop", value: "system" },
];

const selectedOption = computed({
  get: () =>
    options.find((option) => option.value === getThemeMode.value) || options[2],
  set: (newOption) => {
    setThemeMode(newOption.value);
  },
});
</script>

<template>
  <SelectButton
    v-model="selectedOption"
    :options="options"
    option-label="value"
    data-key="value"
    aria-labelledby="theme-selector"
  >
    <template #option="slotProps">
      <i :class="slotProps.option.icon"></i>
    </template>
  </SelectButton>
</template>
